module.exports = __webpack_public_path__ + "img/car_sendai24.8bfebeb2.jpg";